export default __webpack_public_path__ + "static/media/splashBackground.44864efb.png";